<!-- 
TransferTab65.vue
功能：轄下準未訪件接觸追蹤表
作者：i9400538 陳博承
完成：2021-09-16
-->
<template>
  <main>
    <tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h4 class="text-green">轄下準未訪件接觸追蹤表</h4>
              <form action class="form">
                <div class="form-group">
                  <label>拜訪月份</label>
                  <select class="form-control form-control-inline" v-model="form.startYear">
                    <option
                      v-for="(year, yearIndex) in yearOpt"
                      :key="`service-year-${yearIndex}`"
                      :value="year.value"
                    >{{year.text}}</option>
                  </select>
                  <span class="text">/</span>
                  <select class="form-control form-control-inline" v-model="form.startMonth">
                    <option
                      v-for="(month, monthIndex) in monthOpt"
                      :key="`service-month-${monthIndex}`"
                      :value="month.value"
                    >{{month.text}}</option>
                  </select>
                  <span class="text">～</span>
                  <select class="form-control form-control-inline" v-model="form.endYear">
                    <option
                      v-for="(year, yearIndex) in yearOpt"
                      :key="`service-year-${yearIndex}`"
                      :value="year.value"
                    >{{year.text}}</option>
                  </select>
                  <span class="text">/</span>
                  <select class="form-control form-control-inline" v-model="form.endMonth">
                    <option
                      v-for="(month, monthIndex) in monthOpt"
                      :key="`service-month-${monthIndex}`"
                      :value="month.value"
                    >{{month.text}}</option>
                  </select>
                  <a class="btn btn-primary mt-0" @click="initSearchData()">查詢</a>
                </div>
              </form>

              <div class="breadcrumb row" v-if="tableRow && tableRow.length">
                <label class="col-1 text-right">路徑</label>
                <div class="col-7">
                  <ul class="breadcrumb-list">
                    <li
                      class="bread"
                      :class="{
                                'active': bread.level === currentLevel
                                }"
                      v-for="(bread, i) in breadCrumbs"
                      :key="`bread-${i}`"
                    >
                      <a role="button" @click="currentLevel = bread.level">{{bread.name | getCedvnmText}}</a>
                    </li>
                  </ul>
                </div>
                <div class="col-4 text-right">
                  <a @click="downloadData()" class="btn btn-default">下載本頁資料</a>
                  <a v-if="breadCrumbs[breadCrumbs.length-1].target != 'lev6'" @click.prevent="panelOpen('ceadcdChooseModalOpen')" class="btn btn-default">下載轄下資料</a>
                </div>
              </div>
            </div>
            <div class="col-12" :class="{'section-loading': isDataTreeLoading}">
              <table class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th class="text-center" rowspan="2" v-if="breadCrumbs.length < 2">系統別</th>
                    <th class="text-center" rowspan="2" v-else-if="breadCrumbs.length==2">區別</th>
                    <th
                      class="text-center"
                      rowspan="2"
                      v-else-if="breadCrumbs[breadCrumbs.length-1].target=='lev6'"
                    >業務員姓名</th>
                    <th class="text-center" rowspan="2" v-else>單位</th>
                    <th class="text-center" colspan="3">準未訪件</th>
                    <th class="text-center" colspan="3">準自招未訪件</th>
                  </tr>
                  <tr>
                    <th class="text-right">應完成人數</th>
                    <th class="text-right">已完成人數</th>
                    <th class="text-right">完成率</th>
                    <th class="text-right">應完成人數</th>
                    <th class="text-right">已完成人數</th>
                    <th class="text-right">完成率</th>
                  </tr>
                </thead>
                <tbody v-if="tableRow && tableRow.length">
                  <tr v-for="(row, rid) in tableRow" :key="`row-${rid}`">
                    <td>
                      <a
                        v-if="row.child && breakType != 'lev6'"
                        @click="searchData(row.cedvnm, row.cedvno)"
                        class="link text-underline"
                      >{{row.cedvnm | getCedvnmText}}</a>
                      <span v-else-if="row.child">{{row.cedvnm | getCedvnmText}}</span>
                      <span v-else>{{row.cedvnm | getCedvnmText}}</span>
                    </td>
                    <td class="text-right">{{row.thism | numberFormat}}</td>
                    <td class="text-right">{{row.z_remain | numberFormat}}</td>
                    <td class="text-right">{{row.z_remain_rate1 + '%'}}</td>
                    <td class="text-right">{{row.thism_2 | numberFormat}}</td>
                    <td class="text-right">{{row.z_remain_2 | numberFormat}}</td>
                    <td class="text-right">{{(row.z_remain_rate1_2) + "%"}}</td>
                  </tr>
                </tbody>
                <tbody v-else-if="currentLevel && !tableRow.length">
                  <tr>
                    <td class="empty-block bg-white" colspan="7">
                      <h1 class="bg-white">無任何資料</h1>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="empty-block bg-white" colspan="7">
                      <h1 class="bg-white">點擊查詢顯示資料</h1>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div v-if="tableRow && tableRow.length">
                當月份準未訪/準自招未訪件應拜訪人數，於『當月第三週第一個上班日』更新<br>
                如有其他疑問，請洽總公司業務部業務企劃科，(02)27551399#{{ contactInfo.contact_tel }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Ceadcd-Choose-Modal
      :open="ceadcdChooseModalOpen"
      :dis="dis"
      @close="panelClose('ceadcdChooseModalOpen')"
      @choose="chooseCeadcd"
    />
  </main>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
//component
import TabHeader from "@/desktop/components/manager/TabHeader";
import CeadcdChooseModal from '../manager/condition/components/ceadcdChooseModal'
//service
import { queryTheRemoteDocumentTracking, downloadTheRemoteDocumentTracking, getContactInfoBySerNo } from "@/service";
import { saveAs } from "file-saver";

export default {
  name: "TransferTab65",
  mixins: [commonMixin],
  components: {
    TabHeader, CeadcdChooseModal
  },
  computed: {
    tableRow() {
      this.checkBreadCrumbs();
      return this.dataTree[this.currentLevel - 1];
    }
  },
  data() {
    return {
      ceadcdChooseModalOpen: false,
      form: {
        startYear: "",
        startMonth: "",
        endYear: "",
        endMonth: ""
      },
      yearOpt: [],
      monthOpt: [],
      isDataTreeLoading: false,
      currentLevel: 0,
      apiTarget: {},
      breadCrumbs: [],
      dataTree: [],
      breakType: "",
      dis: '51',
      contactInfo: []
    };
  },
  watch: {
    "form.startYear": function(newValue, oldValue) {
      this.checkDate(newValue, oldValue, "startYear");
    },
    "form.startMonth": function(newValue, oldValue) {
      this.checkDate(newValue, oldValue, "startMonth");
    },
    "form.endYear": function(newValue, oldValue) {
      this.checkDate(newValue, oldValue, "endYear");
    },
    "form.endMonth": function(newValue, oldValue) {
      this.checkDate(newValue, oldValue, "endMonth");
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    checkBreadCrumbs() {
      if (this.dataTree.length > this.currentLevel) {
        this.breakType = "";
        this.dataTree.length = this.currentLevel;
        this.breadCrumbs.length = this.currentLevel;
      }
    },
    syncBreadCrumbs() {
      if (this.currentLevel == 1) {
        this.breadCrumbs = [
          { level: 1, target: "lev1", cedvno: "0", name: "全部" }
        ];
      } else {
        this.breadCrumbs.push(this.apiTarget);
      }
    },
    initSearchData() {
      this.currentLevel = 0;
      this.dataTree = [];
      this.breadCrumbs = [];
      this.searchData();
    },
    searchData(name, cedvno) {
      let target = this.searchTarget(cedvno);
      this.apiTarget = {
        level: this.currentLevel + 1,
        target: target,
        cedvno: cedvno,
        name: name
      };

      let lastDay = new Date(
        this.form.endYear,
        parseInt(this.form.endMonth),
        0
      ).getDate(); //取每月最後一天
      let startDate = `${this.form.startYear}-${this.form.startMonth}-01`;
      let endDate = `${this.form.endYear}-${this.form.endMonth}-${lastDay}`;
      this.isDataTreeLoading = true;
      queryTheRemoteDocumentTracking(
        this.$store.state.userInfo.id,
        target,
        startDate,
        endDate,
        cedvno
      ).then(result => {
        if (result.header && result.header.status == "200") {
          let checkedDatas = result.body["query_" + target].map(item => {
            if(!item.z_remain_rate1_2){
              item.z_remain_rate1_2 = 0;
            }
            if (item.cedvno == "0") {
              item["child"] = false;
              return item;
            } else {
              item["child"] = true;
              return item;
            }
          });
          checkedDatas.sort(this.sortCompareFun());
          this.breakType = target;
          this.dataTree.push(checkedDatas);
          this.currentLevel++;
          this.syncBreadCrumbs();
        } else {
          if (result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢失敗,請重新操作" });
          }
        }
        this.isDataTreeLoading = false;

        //  for 難字更新姓名
        if (target == "lev6") {
          this.registerHanlink();
        }
      });
    },
    //下載相關功能 - START
    downloadData(targetVal) {      
      let nowBreadCrumb = this.breadCrumbs[this.breadCrumbs.length - 1];
      let target = nowBreadCrumb.target;
      let cedvno =  nowBreadCrumb.cedvno;
      if(targetVal) {
        target = 'lev' + targetVal;
        cedvno = 'null';
      }
      this.isDataTreeLoading = true;
      let lastDay = new Date(this.form.endYear, parseInt(this.form.endMonth), 0).getDate(); //取每月最後一天
      let startDate = `${this.form.startYear}-${this.form.startMonth}-01`
      let endDate = `${this.form.endYear}-${this.form.endMonth}-${lastDay}`
      downloadTheRemoteDocumentTracking(this.$store.state.userInfo.id, target, startDate, endDate, cedvno).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            let vm = this;
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            let fileName = '轄下準未訪件接觸追蹤表.xlsx';
            if(targetVal) {
              if(targetVal == '2'){
                fileName = '區部總表.xlsx';
              }else if(targetVal =='3'){
                fileName = '區部轄下通訊處總表.xlsx';
              }else if(targetVal =='4'){
                fileName = '展業轄下展業課.xlsx';
              }else if(targetVal =='5'){
                fileName = '專招轄下推展處.xlsx';
              }else if(targetVal =='6'){
                fileName = '展業轄下展業區.xlsx';
              }
            }
            saveAs(result, fileName);           
          }

          this.isDataTreeLoading = false;
        });
    },
    chooseCeadcd(val) {
      this.panelClose('ceadcdChooseModalOpen');
     this.downloadData(val);
    },
    //下載相關功能 - END
    searchTarget(cedvno) {
      if (this.breadCrumbs.length == 0) {
        return "lev1";
      } else {
        let lastTarget = this.breadCrumbs[this.breadCrumbs.length - 1].target;

        // 權限
        if (lastTarget == "lev3") {
          // 取得第3碼，判斷是1還是4
          if(cedvno.length === 3 && cedvno.charAt(2) === "1"){
            // 專招            
            lastTarget += '_1'
          } else {
            // 展業
            lastTarget += '_4'
          }
        }

        switch (lastTarget) {
          case "lev1":
            return "lev2";
          case "lev2":
            return "lev3";
          case "lev3_1":
            return "lev51";
          case "lev3_4":
            return "lev44";
          case "lev44":
            return "lev54";
          case "lev54":
            return "lev6";
          case "lev51":
            return "lev6";
          default:
            return "error";
        }
      }
    },
    sortCompareFun() {
      return function(a, b) {
        if (a["cedvno"] == "0") {
          return 1;
        }
        if (b["cedvno"] == "0") {
          return -1;
        }
        let result =
          a["cedvno"] < b["cedvno"] ? -1 : a["cedvno"] > b["cedvno"] ? 1 : 0;
        return result;
      };
    },
    initMonthOpt() {
      for (let i = 1; i < 13; i++) {
        let selectItem = {
          value: String(i).length == 1 ? "0" + String(i) : String(i),
          text: `${i}月`
        };
        this.monthOpt.push(selectItem);
      }
      let currentMonth = String(new Date().getMonth() + 1);
      if (currentMonth.length == 1) {
        currentMonth = "0" + currentMonth;
      }
      this.form.startMonth = currentMonth;
      this.form.endMonth = currentMonth;
    },
    initYearOpt() {
      let westYear = new Date().getFullYear();
      for (let i = westYear - 5; i <= westYear; i++) {
        if (i >= 2020) {
          let selectItem = {
            value: String(i),
            text: `${i - 1911}年`
          };
          this.yearOpt.push(selectItem);
        }
      }
      let currentWestYear = String(westYear);
      this.form.startYear = currentWestYear;
      this.form.endYear = currentWestYear;
    },
    initContactInfo(){
      // 以流水編號查詢企劃單位連絡方式
      getContactInfoBySerNo(this.$store.state.userInfo.id, '11').then(result => {
        if(result && result.header.status == '200' && result.body){
            this.contactInfo  = result.body.lists[0];
        }
      })
    },
    checkDate(newValue, oldValue, buttonTag) {
      if (oldValue != "") {
        let startDate;
        let endDate;
        startDate = Date.parse(
          `${this.form.startYear}/${this.form.startMonth}`
        );
        endDate = Date.parse(`${this.form.endYear}/${this.form.endMonth}`);
        if (startDate - endDate > 0) {
          this.form[buttonTag] = oldValue;
          this.$toast.info({ title: "起年月不可小於迄年月" });
        }
      }
    }
  },
  beforeMount() {
    this.initMonthOpt();
    this.initYearOpt();
  },
  mounted() {
    //獲得企劃單位聯絡資訊
    this.initContactInfo()
  }
};
</script>
<style lang="scss" scoped>
.text-center {
  text-align: center;
}
</style>